import { useState, useEffect } from 'react'

const useNonDeletableItemsData = (domainUsageList, fullList) => {
  const [nonDeletableItems, setNonDeletableItems] = useState([])

  useEffect(() => {
    if (domainUsageList.length === 0) return
    const fullListArray = Array.isArray(fullList) ? fullList : [fullList]

    const fullMap = fullListArray.reduce((acc, elem) => {
      acc[elem.id] = elem
      return acc
    }, {})

    setNonDeletableItems(
      domainUsageList
        .map(({ resourceId, dependencies }) => {
          const item = fullMap[resourceId]
          return item ? { ...item, dependencies } : null
        })
        .filter(elem => elem !== null)
    )
  }, [domainUsageList, fullList])

  return nonDeletableItems
}

export default useNonDeletableItemsData
